import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";
import main from "../assets/ductareanets.webp";

import img1 from "../assets/ductria/1.jpg";
import img2 from "../assets/ductria/2.jpg";
import img3 from "../assets/ductria/3.jpg";

import Images from "./Images";
import { Helmet } from "react-helmet-async";

export default function DucteriaNets() {
       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Duct Area Net for Apartments- residential in Bengaluru",
    url: "https://www.anssafetynets.com/ducterianets",
    description:
      "Protect your apartment's duct areas with our high-quality duct area netting solution, designed for enhanced safety, hygiene, and ventilation efficiency. Made from durable, weather-resistant materials, our nets prevent the entry of birds, rodents, and debris, ensuring a clean and secure environment.",
    keywords: [
      "duct net for apartment",
      "bird netting for ducts",
      "duct area protection",
      "safety net for ducts",
      "pest control netting",
      "apartment duct net installation",
      "duct area net installation Bengaluru",
      "duct net for buildings",
      "duct net installation in Bangalore",
      "bird netting services in Bengaluru",
      "apartment duct netting services",
      "balcony and duct netting service",
      "building duct area safety solution",
      "anti-debris net for apartment duct",
      "duct area net",
      "apartment duct net",
      "bird net for duct",
      "duct protection net",
      "safety net for duct",
      "net for apartment ducts",
    ],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Ducteria Nets",
          item: "https://www.anssafetynets.com/ducterianets",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Ducteria Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };
  return (
    <div>
      <Helmet>
        <title>Duct Area Net for Apartments- residential in Bengaluru</title>
        <meta
          name="description"
          content="Protect your apartment's duct areas with our high-quality duct area netting solution,
designed for enhanced safety, hygiene, and ventilation efficiency. Made from durable,
weather-resistant materials, our nets prevent the entry of birds, rodents, and debris,
ensuring a clean and secure environment."
        />
        <meta
          name="keywords"
          content="Duct net for apartment
bird netting for ducts
duct area protection
safety net for ducts
pest control netting
apartment duct net installation
Duct area Net installation Bengaluru 
Duct net for buildings
Duct net installation in Bangalore 
Bird netting services in Bengaluru 
Apartment duct netting services 
Balcony and duct netting service
Building duct area safety solution
Anti-debris net for apartment duct
Duct area net
Apartment duct net
Bird net for duct
Duct protection net
Safety net for duct
Net for apartment ducts"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/ducterianets"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <HeroSection
        title="Ducteria Nets"
        description="Protect air ducts and other narrow spaces with our specialized ducteria safety nets."
        bgColor="bg-[#37474f]"
      />

      <ProductDetails
        title="Why Choose Our Ducteria Nets?"
        content="At ANS Safety Nets, we offer ducteria nets that are specifically designed to prevent debris, pests, and other unwanted materials from entering your ducts, while still allowing for proper airflow. Made from durable, high-quality materials, our ducteria nets provide an effective barrier against contaminants, ensuring that your ventilation and air conditioning systems remain clean and efficient. These nets are easy to install and maintain, offering long-lasting protection without compromising airflow. With ANS Safety Nets, you can ensure the hygiene and functionality of your ducts, keeping your environment safe and comfortable at all times."
        image={main}
      />

      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Airflow Preservation",
            description: "Maintain proper airflow while protecting your ducts.",
          },
          {
            title: "Durability",
            description:
              "Our nets are resistant to wear and tear, ensuring long-term use.",
          },
          {
            title: "Easy Installation",
            description:
              "Quick and easy to install, perfect for various duct systems.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "Can these nets fit all duct sizes?",
            answer: "Yes, we offer custom sizes to fit all types of ducts.",
          },
          {
            question: "Are the nets fire-resistant?",
            answer:
              "Yes, our ducteria nets are made from fire-resistant materials.",
          },
        ]}
      />
    </div>
  );
}
